import { Component, Prop, h, Host } from '@stencil/core';

/**
 * Banner component for SignNow brand
 *
 * @product signnow
 * @version 1.2.0
 * @category SignNow
 * @contentConfig Top banner with action buttons for support and login
 * @slot actions - {required}, {multiple}, <me-button variant="ghost" size="sm" href="..."> - Action buttons
 * @example
 *   <sn-banner-type-1>
 *     <me-button slot="actions" variant="ghost" size="sm" href="https://support.signnow.com">Support</me-button>
 *     <me-button slot="actions" variant="ghost" size="sm" href="https://app.signnow.com">Login</me-button>
 *   </sn-banner-type-1>
 */
@Component({
  tag: 'sn-banner-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNBannerType1 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <header role="banner">
          <popup-banner-type-2>
            <slot name="actions"></slot>
          </popup-banner-type-2>
        </header>
      </Host>
    );
  }
}
